module.exports = __webpack_public_path__ + "weight.4e12d9ba.png";


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/src/components/profile/imgs/weight.png
// module id = 2396
// module chunks = 0